export const TERMS_AND_CONDITIONS_TEXT_ID = '10';
export const PROMOTION_NAME_TEXT_ID = '5';
export const IVA = 'IVA';
export const TEXTO_INICIAL_TERMINOS_PROMOCIONES =
  'Te proporcionamos el resumen de contrato de los servicios de comunicaciones que vas a contratar para que puedas descargártelos';
export const TITULO_PRODUCTOS = 'Condiciones Promociones';
export const TITULO_CONDICIONES_PARTICULARES =
  'Condiciones particulares y generales';
export const TEXTO_CONDICIONES_PARTICULARES =
  'Condiciones particulares y generales en ';
export const LINK_CONDICIONES_PARTICULARES =
  'https://www.movistar.es/contratos';
export const TEXTO_LINK_CONDICIONES_PARTICULARES = 'movistar.es/contratos.';
